module.exports = __webpack_public_path__ + "img/wb.ce245a94.png";